module.exports = __webpack_public_path__ + "static/media/39.6745131.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/39.wav
// module id = wpmN
// module chunks = 0